import { Tag } from './HeaderTag.styled'

type HeaderTagProps = {
  dataTest?: string
}

const HeaderTag: React.FC<HeaderTagProps> = ({ children, dataTest }) => (
  <Tag data-test={dataTest}>{children}</Tag>
)

export default HeaderTag
